import axios from 'axios'
import CircularIndeterminate from 'components/CircularIndeterminate'
import { getSettings, removeCurrentUser, setCurrentUser } from 'helpers/storage'

import { setCmmnCd } from 'hooks/cmmnCodeFactory'
import { removeGlobalAlert } from 'hooks/globalError'
import { setGnbToggle } from 'hooks/gnbToggle'
import { setPos1, setPos2 } from 'hooks/pagePos'
import { removeUserInfo, setUserInfo } from 'hooks/userInfo'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import styled from 'styled-components'

interface SettingsModel {
	desnse: string
	row: number
	zoom: string
	res: string
	ocs: string
}

interface UserModel {
	accessToken: string
	refreshToken: string
	tokenType: string
	expiryDuration: number
}

const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	height: 100vh;
	background-color: #f0f0f0;
	font-family: 'Roboto', sans-serif;
	color: #333;
`

const Auth = () => {
	// URL 파라미터로 붙어서 오는 키가 key라고 되어 있는 부분을 읽는다.
	const { key } = useParams<{ key: string }>()
	console.log('key', key)

	const dispatch = useDispatch()
	const navigate = useNavigate()
	const settingValues = getSettings()

	const [variables] = useState<SettingsModel>({
		desnse: settingValues.desnse ? settingValues.desnse : 'compact',
		row: settingValues.row ? settingValues.row : 10,
		zoom: settingValues.zoom ? settingValues.zoom : '100%',
		res: settingValues.res ? settingValues.res : 'n',
		ocs: settingValues.ocs ? settingValues.ocs : 'n',
	})

	axios
		.get(`${process.env.REACT_APP_HOST2}/user/me`, {
			headers: {
				Authorization: `Bearer ${key}`,
			},
		})
		.then((res) => {
			// console.log(res.data)
			const { data } = res
			console.log(data)
			// 토큰 저장
			const UserModel: UserModel = {
				accessToken: key ?? '',
				expiryDuration: 43200000, // 12시간
				tokenType: 'Bearer ',
				refreshToken: '',
			}
			setCurrentUser(UserModel)
			// // 사용자 정보 저장
			dispatch(setUserInfo(data))

			// console.log(data)

			let url = '/admin/dashboard'

			if (data.isEmpSub) {
				dispatch(setGnbToggle(false))
				dispatch(setPos1({ title: '검사결과', link: '' }))
				dispatch(setPos2({ title: '슬라이드 대여 신청', link: '/admin/sbRequest' }))
				url = '/admin/sbRequest'
			} else {
				if (variables.res === 'n') {
					dispatch(setGnbToggle(false))
					dispatch(setPos1({ title: '검사결과', link: '' }))
					dispatch(setPos2({ title: '결과조회', link: '/admin/test/result' }))
					url = '/admin/test/result'
				} else if (variables.res === 'v') {
					dispatch(setGnbToggle(false))
					dispatch(setPos1({ title: '검사결과', link: '' }))
					dispatch(setPos2({ title: '결과조회', link: '/admin/test/resultOldV11' }))
					url = '/admin/test/resultOldV11'
				} else if (variables.res === 'v2') {
					dispatch(setGnbToggle(false))
					dispatch(setPos1({ title: '검사결과', link: '' }))
					dispatch(setPos2({ title: '결과조회', link: '/admin/test/resultV2' }))
					url = '/admin/test/resultV2'
				} else {
					dispatch(setGnbToggle(false))
					dispatch(setPos1({ title: '검사결과', link: '' }))
					dispatch(setPos2({ title: '결과조회', link: '/admin/test/resultOld' }))
					url = '/admin/test/resultOld'
				}
			}
			// 공통코드 저장
			axios
				.get(`${process.env.REACT_APP_HOST2}/cmmn/codeList`)
				.then((res) => {
					// console.log(res.data)
					const { data } = res
					// 공통 코드 저장
					dispatch(setCmmnCd(data))
					dispatch(setGnbToggle(false))
					navigate(url, { replace: true })
				})
				.finally(() => {})
		})
		.catch((error) => {
			navigate('/')
			removeCurrentUser()
			dispatch(removeGlobalAlert())
			dispatch(removeUserInfo())
		})
		.finally(() => {})

	return (
		<Container>
			<CircularIndeterminate />
		</Container>
	)
}

export default Auth
